import React, { memo, useContext, useEffect, useState } from "react";


import { logApi, MainSumApi } from "../../../../../../../api/Api";
import { Box, Card, CardActions, CardHeader, Container, CssBaseline, Grid, IconButton, Paper, Stack, Typography, colors, useTheme } from '@mui/material';


import { InverterContext } from '../../../../../../../context/InverterContext';
import { AppThemeContext } from '../../../../../../../context/AppThemeContext';
import backgroundImage from '../../../../../../../assets/img/bg/chart2.png';
import { AuthenticationContext } from '../../../../../../../context/AuthenticationContext'

import SettingsIcon from '@mui/icons-material/Settings';

import AutorenewIcon from '@mui/icons-material/Autorenew';

import SolarSvg2 from "../../../../../../../assets/svg/lastSolarSvg2";

import { getDateTimeForDashboardTab1, getFromTo } from '../../../../../../../utils'

import AppModal from "../../../../../../../components/AppModal";
import InvverterFullSize from "../../../../../../../components/inverter/InvverterFullSize";
import Load3Svg from "../../../../../../../assets/svg/Load3Svg";




function Load3SvgImage() {
    const { LoggedInUserInfo } = React.useContext(AuthenticationContext)

    const { PrimaryColor } = useContext(AppThemeContext);

    const { spacing, palette, shape: { borderRadius } } = useTheme();
    const { getHYBRD_Info, HYBRD_DATA_POWER_Loading, HYBRD_DATA_INFO, getPostKwhHybridForDashboard, getHYBRD_Power, HYBRD_DATA_POWER, POST_KWH_HYBRID_DATA_DASHBOARD } = useContext(InverterContext);

    const [logData, setLogData] = useState([]);
    const [mainData, setMainData] = useState([]);
    const [StartDate, setStartDate] = useState(getDateTimeForDashboardTab1().LastDay)
    const [EndDate, setEndDate] = useState(getDateTimeForDashboardTab1().Today)

    const [OpenMix, setOpenMix] = useState(false);
    const handleOpenMix = () => setOpenMix(true);
    const handleCloseMix = () => setOpenMix(false);

    const [credentials, setCredentials] = useState({
        LOGIN_ID: localStorage.getItem("LoginID"),
        LOC_CODE: localStorage.getItem("LCODE"),
        PASS_KEY: localStorage.getItem("PASS_KEY") || "DEFAULT_PASS_KEY",
        WEB_KEY: localStorage.getItem("WEB_KEY") || "DEFAULT_WEB_KEY",
    });


    const [sumCredentials, setSumCredentials] = useState({
        LOGIN_ID: localStorage.getItem("LoginID") || "",
        PASS_KEY: localStorage.getItem("KEY") || "xyz",
        LCODE: localStorage.getItem("LCODE") || "",
        DT1: StartDate,
        DT2: EndDate,
        TYP: "A",
        WEB_KEY: "WEBXYZ321",
        FID: "216HT001",
    });



    // this is fetching for MIDDLE data
    const fetchLogData = async () => {
        const res = await logApi(credentials);
        if (res?.TOT_LIVE_KW_NEW && Array.isArray(res.TOT_LIVE_KW_NEW)) {
            setLogData(res.TOT_LIVE_KW_NEW);
        } else {
            setLogData([]);
        }
    };

    // useEffect(() => {
    //     fetchLogData();
    // }, [credentials]); // Fetch new data when credentials change


    // this is fetching for MAIN_SUM
    const fetchData = async () => {
        const res = await MainSumApi(sumCredentials);
        if (res?.KWH_MIS_MAIN_SUM && Array.isArray(res.KWH_MIS_MAIN_SUM)) {
            setMainData(res.KWH_MIS_MAIN_SUM);
        } else {
            setMainData([]);
        }
    };

    // useEffect(() => {
    //     fetchData();
    // }, [sumCredentials]); // Fetch new data when credentials change

    // console.log("LoggedInUserInfo",LoggedInUserInfo)

    useEffect(() => {
        // Fetch data immediately on mount
        fetchLogData();
        fetchData();

        // Set interval to fetch data every 30 seconds
        const interval = setInterval(() => {
            fetchLogData();
            fetchData();
        }, 60000); // 30 seconds in milliseconds

        // Cleanup interval on unmount
        return () => clearInterval(interval);
    }, [credentials, sumCredentials]); // Dependencies to trigger re-setup if these values change



    const blinkingAnimationDateTime = {
        fontWeight: "900",
        animation: 'blinkingAnimationDateTime 2s infinite',
        transition: 'color 0.5s ease-in-out',
    }
    const blinkingAnimationBatteryStatusCharging = {
        fontWeight: "900",
        animation: 'blinkingAnimationDateTime 2s infinite',
        transition: 'color 0.5s ease-in-out',
        color: 'green'
    }
    const blinkingAnimationBatteryStatusDischarging = {
        fontWeight: "900",
        animation: 'blinkingAnimationDateTime 2s infinite',
        transition: 'color 0.5s ease-in-out',
        color: 'red'
    }

    const styles = {
        IconStyle: {
            color: 'primary.main',
            fontSize: '1rem'
        }
    }

    return (

        <>


            <Grid container style={{ padding: "0", margin: "0" }}>
                {logData.map((log, index) => (
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12} padding={spacing(0)}>
                        <Container sx={{ maxWidth: '100%', height: 'auto', position: 'relative' }}>
                            {/* <img
                                src={backgroundImage}
                                alt="Background"
                                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                            /> */}

                            <Load3Svg svgColor={palette.primary.main} />

                            <Typography variant='body2' sx={{ position: 'absolute', top: '1%', left: '0%', color: "black", fontSize: '0.2rem' }} className="">

                                <span style={{ fontSize: '0.8rem' }}> {log.SOLAR_P_1_PLANT_NAME !== undefined ? log.SOLAR_P_1_PLANT_NAME : "N/A"}</span>&nbsp;<span style={{ fontSize: '0.8rem' }}>{log.SOLAR_P_1_KWP !== undefined ? log.SOLAR_P_1_KWP : "N/A"}</span>
                            </Typography>

                            <Typography
                                variant="body2"
                                sx={{
                                    position: "absolute",
                                    top: "8%",
                                    left: "0%",
                                    color: "red",

                                }}
                                className="blink"
                            >
                                <span style={{ fontSize: '0.8rem' }}>{log.SOLAR_P_1_KW !== undefined ? log.SOLAR_P_1_KW : "N/A"} </span>

                            </Typography>

                            <Typography
                                variant="body2"
                                sx={{
                                    position: "absolute",
                                    top: "16%",
                                    left: "0%",
                                    color: "red",
                                }}
                                className="blink"
                            >
                                <span style={{ fontSize: '0.8rem' }}> {log.SOLAR_P_1_KWH !== undefined ? log.SOLAR_P_1_KWH : "N/A"}</span>

                            </Typography>

                            <Typography
                                variant="body2"
                                sx={{
                                    position: "absolute",
                                    top: "2%",
                                    right: "40%",
                                    color:
                                        log.PLANT_STATUS?.toLowerCase() === "plant online"
                                            ? "green"
                                            : log.PLANT_STATUS?.toLowerCase() === "plant offline"
                                                ? "red"
                                                : "inherit", // fallback if status is something else or undefined
                                }}
                            >
                                 <span style={{fontSize:"1.3rem"}}>{log.PLANT_STATUS !== undefined ? log.PLANT_STATUS : "N/A"}</span>
                            </Typography>


                            <Typography variant='body2' sx={{ position: 'absolute', top: '28%', left: '0%', color: "black" }} className="" >
                                <span style={{ fontSize: '0.8rem' }}>{log.SOLAR_P_2_PLANT_NAME !== undefined ? log.SOLAR_P_2_PLANT_NAME : "N/A"}</span>&nbsp;<span style={{ fontSize: '0.8rem' }}>{log.SOLAR_P_2_KWP !== undefined ? log.SOLAR_P_2_KWP : "N/A"}</span>
                            </Typography>

                            <Typography variant='body2' sx={{ position: 'absolute', top: '43%', left: '0%', color: "red" }} className="blink" >
                                <span style={{ fontSize: '0.8rem' }}>{log.SOLAR_P_2_KWH !== undefined ? log.SOLAR_P_2_KWH : "N/A"}</span>

                            </Typography>

                            <Typography variant='body2' sx={{ position: 'absolute', top: '35%', left: '0%', color: "red" }} className="blink" >
                                <span style={{ fontSize: '0.8rem' }}> {log.SOLAR_P_2_KW !== undefined ? log.SOLAR_P_2_KW : "N/A"}</span>

                            </Typography>



                            <Typography variant='body2' sx={{ position: 'absolute', bottom: '38%', left: '0%', color: "black" }} className="" >
                                <span style={{ fontSize: '0.8rem' }}>{log.SOLAR_P_3_PLANT_NAME !== undefined ? log.SOLAR_P_3_PLANT_NAME : "N/A"}</span>&nbsp;<span style={{ fontSize: '0.8rem' }}>{log.SOLAR_P_3_KWP !== undefined ? log.SOLAR_P_3_KWP : "N/A"}</span>
                            </Typography>

                            <Typography variant='body2' sx={{ position: 'absolute', bottom: '21%', left: '0%', color: "red" }} className="blink" >
                                <span style={{ fontSize: '0.8rem' }}>{log.SOLAR_P_3_KWH !== undefined ? log.SOLAR_P_3_KWH : "N/A"} </span>

                            </Typography>

                            <Typography variant='body2' sx={{ position: 'absolute', bottom: '29%', left: '0%', color: "red" }} className="blink" >
                                <span style={{ fontSize: '0.8rem' }}> {log.SOLAR_P_3_KW !== undefined ? log.SOLAR_P_3_KW : "N/A"}</span>
                                {/* {log.SOLAR_P_2_KW !== undefined ? log.SOLAR_P_2_KW : "N/A"}  */}
                            </Typography>




                            <Typography variant='body2' sx={{ position: 'absolute', top: '28%', right: '27%', color: "red" }} className="blink" >
                                <span style={{ fontSize: '0.8rem' }}> {log.GRID !== undefined ? log.GRID : "N/A"} kW</span>

                            </Typography>

                            <Typography variant='body2' sx={{ position: 'absolute', top: '35%', right: '14%', color: "red" }} className="blink" >
                                <span style={{ fontSize: '0.8rem' }}> {log.FRQ !== undefined ? log.FRQ : "N/A"} &nbsp;Hz</span>

                            </Typography>

                            {/* <Typography variant='h6' textAlign={'center'} color={'primary.main'} sx={{ position: 'absolute', top: '44%', right: '52%' }}>
                            {HYBRD_DATA_INFO?.PSTS}
                        </Typography> */}

                            <Typography variant='body2' sx={{ position: 'absolute', bottom: '14%', right: '14%', color: "red" }} className="blink" >
                                <span style={{ fontSize: '0.8rem' }}> {log.TOTAL_LOAD !== undefined ? log.TOTAL_LOAD : "N/A"} Kw</span>

                            </Typography>

                            {/* <Box sx={{ position: 'absolute', top: '10%', left: '38%' }}>
                            <Typography textAlign={'center'} variant='body2'>
                                {HYBRD_DATA_INFO?.DATE_TIME}
                            </Typography>
                            <Typography textAlign={'center'} variant='body2'>
                                {HYBRD_DATA_INFO?.STATUS}
                            </Typography>
                        </Box> */}

                            {/* <Box sx={{ position: 'absolute', bottom: '-4%', left: '36%' }}>
                            <Typography variant='body2' textAlign={'center'}>ALARM</Typography>
                            <Typography variant='body2' style={blinkingAnimationDateTime}>
                                {HYBRD_DATA_INFO?.ALARM}
                            </Typography>
                        </Box> */}
                        </Container>
                    </Grid>
                ))}


            </Grid>



        </>
    );
}


export default memo(Load3SvgImage)